import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import ComponentImage from "GeneralComponents/ComponentImage";
import LimitedContent from "GeneralComponents/LimitedContent";
import { ContentShowListProps as Props } from 'MiniSiteComponents/ContentShow/ContentShow.interface'
import "./PhotoList.css";
import { decodeHtmlEntities } from "../../../Interfaces/utils/Utils";


const PhotoListItem: React.FC<Props> = (props) => {

    const { componentId, iconView, isShowMore, dir, items, noImagesClass, linkTarget } = props;
    const itemsToShowOnLoad = (Number(props.itemsNumberInRow) != 7 && Number(props.itemsNumberInRow) > 0) ? Number(props.itemsNumberInRow) : 7;//7;

    return <ul className={`list-posts list-group px-3 px-md-0 ${iconView && 'list-icons'} ${noImagesClass}`}
        id={"mst-content-list-" + componentId} >

        {
            items.map((contentShowItem, index) => {

                const displayClass = ((index < itemsToShowOnLoad || isShowMore) ? " d-md-flex" : " d-none");
                const url = contentShowItem.url || (contentShowItem.link && contentShowItem.link.url);
                const target = linkTarget != "" ? linkTarget : (contentShowItem.link.target != null ? contentShowItem.link.target : "_self");

                return <li key={contentShowItem.index}
                    className={`${displayClass} ${(contentShowItem.url || contentShowItem.link && contentShowItem.link.url) && 'list-item-link'}`} 
                    onClick={() => { url && window.open(url, target) }}>

                    {
                        (contentShowItem.image && !iconView) ?

                            <ComponentImage
                                image={contentShowItem.image}
                                imageClass="img"
                                mobileImage={contentShowItem.mobileImage}
                                mobileImageClass="img"
                                wrapperDivClass="img-holder"
                                cropAlias="rectangleImage" />
                            :
                            <figure className="img-holder">
                              {contentShowItem.icon && contentShowItem.icon != "" && <i className={contentShowItem.icon + " minisite-font-36 pallete-color mx-auto d-flex justify-content-center"}></i> }
                            </figure>

                    }

                    <div className={`${((contentShowItem.image.url && !iconView) || (iconView && contentShowItem.icon)) ? 'col-sm-12 col-md-7 col-lg-9 col-xl-10' : 'col'}`} >

                        <div className="txt">
                            <h3>{contentShowItem.title}</h3>


                        {
                            !contentShowItem.richDescription ?
                                    (<LimitedContent classNames="mst-photoListView-itemDesc mb-3 mb-md-0" htmlContent={decodeHtmlEntities(contentShowItem.content)}></LimitedContent>)
                                :
                                    (<LimitedContent classNames="mst-photoListView-itemDesc mb-3 mb-md-0" htmlContent={decodeHtmlEntities(contentShowItem.richDescription)} clearHTML={true}></LimitedContent>)
                        }
                        </div>

                    </div>

                </li>

            }


            )
        }
    </ul>

}

export default PhotoListItem;